// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.workingDetailsCard {
  margin-top: 5px;
  height: 106px;
  border: 1px solid #f3f5f6;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
}
.workingDetailsCard .container {
  border-left: 6px solid #49ae9e;
  height: 100%;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  display: flex;
  flex-direction: row;
}
.workingDetailsCard .container .employeeImageWrapper {
  width: 152px;
  height: 106px;
}
.workingDetailsCard .container .employeeImageWrapper .employeeImage {
  width: 52px;
  height: 62px;
  margin-left: 50px;
  margin-right: 50px;
  position: relative;
  top: 22px;
}
.workingDetailsCard .container .timeContainer {
  display: flex;
  flex-direction: column;
  margin-top: 28px;
}
.workingDetailsCard .container .timeContainer .rowOne {
  display: flex;
  flex-direction: row;
}
.workingDetailsCard .container .timeContainer .rowOne .repeatImage {
  margin-right: 5px;
  position: relative;
  top: 1.5px;
}
.workingDetailsCard .container .timeContainer .rowOne .repeatImage img {
  width: 16.7px;
  height: 16.7px;
}
.workingDetailsCard .container .timeContainer .rowOne .weekCount,
.workingDetailsCard .container .timeContainer .rowOne .days {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #333333;
}
.workingDetailsCard .container .timeContainer .rowOne .divider {
  width: 12px;
  height: 1px;
  border: 1px solid #e1e1e1;
  transform: rotate(90deg);
  position: relative;
  top: 8px;
}
.workingDetailsCard .container .timeContainer .rowTwo {
  display: flex;
  flex-direction: row;
  margin-top: 8px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
}
.workingDetailsCard .container .timeContainer .rowTwo .time {
  line-height: 20px;
  color: #333333;
}
.workingDetailsCard .container .timeContainer .rowTwo .break {
  line-height: 20px;
  color: #999999;
  margin-left: 6px;
}
.workingDetailsCard .container .hoursContainer {
  flex: 1 1;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.workingDetailsCard .container .hoursContainer .hoursText {
  position: relative;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 18px;
  height: 18px;
  padding: 0px 4px 3px 4px;
  color: #49ae9e;
  border: 1px solid #49ae9e;
  border-radius: 50px;
}
.workingDetailsCard .container .hoursContainer .btn-box {
  display: flex;
  gap: 8px;
  align-items: center;
}
.workingDetailsCard .container .hoursContainer .remove button {
  padding: 3px;
  color: #e47c77;
  font-size: 13px;
}
.workingDetailsCard .container .hoursContainer .remove button:hover {
  text-decoration: underline;
}
.workingDetailsCard .container .hoursContainer .modify button {
  padding: 3px;
  color: #6c96c2;
  font-size: 13px;
}
.workingDetailsCard .container .hoursContainer .modify button:hover {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/screens/viewInformation/workingDetailsCard/workingDetailsCard.scss"],"names":[],"mappings":"AAAA;EAEI,eAAA;EACA,aAAA;EACA,yBAAA;EACA,4CAAA;EACA,kBAAA;AAAJ;AAEI;EACI,8BAAA;EACA,YAAA;EACA,2BAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;AAAR;AAEQ;EACI,YAAA;EACA,aAAA;AAAZ;AACY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAChB;AAGQ;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;AADZ;AAGY;EACI,aAAA;EACA,mBAAA;AADhB;AAEgB;EACI,iBAAA;EACA,kBAAA;EACA,UAAA;AAApB;AACoB;EACI,aAAA;EACA,cAAA;AACxB;AAEgB;;EAEI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAApB;AAEgB;EACI,WAAA;EACA,WAAA;EACA,yBAAA;EACA,wBAAA;EACA,kBAAA;EACA,QAAA;AAApB;AAIY;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAFhB;AAGgB;EACI,iBAAA;EACA,cAAA;AADpB;AAGgB;EACI,iBAAA;EACA,cAAA;EACA,gBAAA;AADpB;AAMQ;EACI,SAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;AAJZ;AAMY;EACI,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,wBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;AAJhB;AAMY;EACI,aAAA;EACA,QAAA;EACA,mBAAA;AAJhB;AAQgB;EACI,YAAA;EACA,cAAA;EACA,eAAA;AANpB;AAQoB;EACI,0BAAA;AANxB;AAWgB;EACI,YAAA;EACA,cAAA;EACA,eAAA;AATpB;AAWoB;EACI,0BAAA;AATxB","sourcesContent":[".workingDetailsCard {\n    // background-color: red;\n    margin-top: 5px;\n    height: 106px;\n    border: 1px solid #f3f5f6;\n    box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.06);\n    border-radius: 8px;\n\n    .container {\n        border-left: 6px solid #49ae9e;\n        height: 100%;\n        border-top-left-radius: 8px;\n        border-bottom-left-radius: 8px;\n        display: flex;\n        flex-direction: row;\n\n        .employeeImageWrapper {\n            width: 152px;\n            height: 106px;\n            .employeeImage {\n                width: 52px;\n                height: 62px;\n                margin-left: 50px;\n                margin-right: 50px;\n                position: relative;\n                top: 22px;\n            }\n        }\n\n        .timeContainer {\n            display: flex;\n            flex-direction: column;\n            margin-top: 28px;\n\n            .rowOne {\n                display: flex;\n                flex-direction: row;\n                .repeatImage {\n                    margin-right: 5px;\n                    position: relative;\n                    top: 1.5px;\n                    img {\n                        width: 16.7px;\n                        height: 16.7px;\n                    }\n                }\n                .weekCount,\n                .days {\n                    font-family: 'Spoqa Han Sans Neo';\n                    font-style: normal;\n                    font-weight: 400;\n                    font-size: 14px;\n                    line-height: 20px;\n                    color: #333333;\n                }\n                .divider {\n                    width: 12px;\n                    height: 1px;\n                    border: 1px solid #e1e1e1;\n                    transform: rotate(90deg);\n                    position: relative;\n                    top: 8px;\n                }\n            }\n\n            .rowTwo {\n                display: flex;\n                flex-direction: row;\n                margin-top: 8px;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 400;\n                font-size: 14px;\n                .time {\n                    line-height: 20px;\n                    color: #333333;\n                }\n                .break {\n                    line-height: 20px;\n                    color: #999999;\n                    margin-left: 6px;\n                }\n            }\n        }\n\n        .hoursContainer {\n            flex: 1;\n            padding: 10px;\n            display: flex;\n            flex-direction: column;\n            align-items: flex-end;\n\n            .hoursText{\n                position: relative;\n                font-family: 'Spoqa Han Sans Neo';\n                font-style: normal;\n                font-weight: 300;\n                font-size: 12px;\n                line-height: 18px;\n                height: 18px;\n                padding: 0px 4px 3px 4px;\n                color: #49ae9e;\n                border: 1px solid #49ae9e;\n                border-radius: 50px;\n            }\n            .btn-box {\n                display: flex;\n                gap:8px;\n                align-items: center;\n            }\n            \n            .remove {\n                button {\n                    padding: 3px;\n                    color: #e47c77;\n                    font-size: 13px;\n\n                    &:hover {\n                        text-decoration: underline;\n                    }\n                }\n            }\n            .modify {\n                button {\n                    padding: 3px;\n                    color: #6c96c2;\n                    font-size: 13px;\n\n                    &:hover {\n                        text-decoration: underline;\n                    }\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
